import { z } from "zod";

export const UnipileResponseSchema = z.object({
	url: z.string(),
	object: z.string(),
});

export const ValidateUnipileResponseSchema = z.object({
	success: z.boolean(),
	error: z.string().optional(),
});

export const LinkedinCapabilitiesSchema = z.object({
	hasLinkedinPremium: z.boolean(),
	hasLiSn: z.boolean(),
	hasAdminRights: z.boolean(),
	checkedAt: z.string(),
});

export type UnipileResponse = z.infer<typeof UnipileResponseSchema>;
export type ValidateUnipileResponse = z.infer<typeof ValidateUnipileResponseSchema>;
export type LinkedinCapabilities = z.infer<typeof LinkedinCapabilitiesSchema>;

/**
 * Unipile row status meaning the Sales Navigator session is disconnected while the
 * base LinkedIn account is still connected. Mirrors the backend
 * `UnipileStatus.LISN_CREDENTIALS`.
 */
export const SALES_NAVIGATOR_DISCONNECTED_STATUS = "LISN_CREDENTIALS";

/** True when the unipile status marks the Sales Navigator session as disconnected. */
export const isSalesNavigatorDisconnectedStatus = (status?: string): boolean =>
	status === SALES_NAVIGATOR_DISCONNECTED_STATUS;

/**
 * Unipile row status meaning the base LinkedIn account was connected before but is now
 * logged out (its `accountId` still exists, so it can be reconnected — not connected
 * fresh). Mirrors the backend `UnipileStatus.CREDENTIALS`.
 */
export const LINKEDIN_DISCONNECTED_STATUS = "CREDENTIALS";

/** True when the unipile status marks the LinkedIn account as previously-connected-now-logged-out. */
export const isLinkedinDisconnectedStatus = (status?: string): boolean =>
	status === LINKEDIN_DISCONNECTED_STATUS;
